// La vista de lanzamiento de Agencias, la MISMA que pinta la app: se importan
// tal cual sus archivos (dejan AgenciasLaunch* en global) y su hoja de
// estilos, así la vista previa del editor es exactamente lo que verá el
// usuario y los valores de fábrica y los topes no se copian aquí.
//   content.js  textos y tarjetas de fábrica, límites, sanitize() y resolve()
//   icons.js    iconos de las tarjetas (lista del desplegable)
//   view.js     la pantalla y su animación de entrada
import '../../../renderer/tabs/agencias/launch/icons.js';
import '../../../renderer/tabs/agencias/launch/content.js';
import '../../../renderer/tabs/agencias/launch/view.js';
import '../../../renderer/styles/views/agency-launch.css';
import logoUrl from '../../../renderer/assets/icons/menu/tikcontrol-agencies-imagotipo.svg';

export const LaunchContent = globalThis.AgenciasLaunchContent;
export const LaunchIcons = globalThis.AgenciasLaunchIcons;
export const LaunchView = globalThis.AgenciasLaunchView;
export const LAUNCH_LOGO_URL = logoUrl;

// La app usa esta fuente; el backoffice no la carga por su cuenta.
export const LAUNCH_FONT_URL = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';
